module.exports = __webpack_public_path__ + "static/media/Promos_2x1.a65eaa40.png";